import { render, staticRenderFns } from "./FlightDetails.vue?vue&type=template&id=4b805a09&scoped=true&"
import script from "./FlightDetails.vue?vue&type=script&lang=js&"
export * from "./FlightDetails.vue?vue&type=script&lang=js&"
import style0 from "./FlightDetails.vue?vue&type=style&index=0&id=4b805a09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b805a09",
  null
  
)

export default component.exports